
import React from 'react'
import  { Box, HBox, VBox } from './Box'

// TODO: imply List.Item isLast?

/**
 * List component.
 */

export default List

/**
 * Expose.
 */

List.Item = Item

/**
 * List component.
 */

function List({ children, ...props }) {
  return <VBox displayName="List" flex {...props}>
    {children}
  </VBox>
}

/**
 * Item component.
 */

function Item({ isLast, children, ...props }) {
  return <HBox
    displayName="ListItem"
    alignX="between"
    alignY="center"
    borderBottom={!isLast}
    paddingY={2}
    {...props}
  >
    {children}
  </HBox>
}